import { useTellescopeInfiniteQuery, useAuth } from "@tellescope/tanstack-query";

export interface UsePortalBrandingsOptions {
  limit?: number;
  enabled?: boolean;
}

/**
 * Hook for fetching portal branding records for the current organization.
 * Uses the Tellescope tanstack-query pattern with session passed directly.
 */
export function usePortalBrandings(options: UsePortalBrandingsOptions = {}) {
  const { limit = 50, enabled = true } = options;
  const { session } = useAuth();

  const query = useTellescopeInfiniteQuery({
    model: "portal_brandings",
    method: "getSome",
    request: {
      filter: {},
      limit,
    },
    session: session ?? undefined, // Pass session directly (bypasses provider context)
    select: (data) => data.pages.flat(),
    enabled: enabled && !!session,
  });

  const allBrandings = query.data ?? [];

  // Sort by title (A-Z)
  const sortedBrandings = [...allBrandings].sort((a, b) => {
    const titleA = a.title || "";
    const titleB = b.title || "";
    return titleA.localeCompare(titleB);
  });

  return {
    ...query,
    brandings: sortedBrandings,
  };
}
